import { render, staticRenderFns } from "./regulation.vue?vue&type=template&id=6dfef39a&scoped=true"
import script from "./regulation.vue?vue&type=script&lang=js"
export * from "./regulation.vue?vue&type=script&lang=js"
import style0 from "./regulation.vue?vue&type=style&index=0&id=6dfef39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfef39a",
  null
  
)

export default component.exports